<template>
  <div>
    <div
      class="flex items-center gap-0.5 p-0.5"
      :class="{
        'border-dashed border border-red-500 shadow-xl': item.editing,
      }"
    >
      <a class="el-icon-edit-outline text-sm" @click="toEdit" />
      <alter-request
        :requester="{ id: item.id, type: 'Container', attr: 'container_no' }"
      >
        {{ item.container_no }}
      </alter-request>
    </div>
    <slot
      v-for="o in (item.transports || [])
        .flatMap((t) => t.operations || [])
        .filter((o) => ['swap', 'mount'].includes(o.mode))"
    >
      <alter-request
        :requester="{ id: o.id, type: 'Operation', attr: 'container_no' }"
        :key="o.id"
      >
        <div class="tag f90">{{ o.container_no }}</div>
      </alter-request>
    </slot>
  </div>
</template>

<script>
export default {
  name: "order-status-cont-no",
  props: {
    item: Object,
    options: Object,
  },
  methods: {
    toEdit() {
      this.$set(this.item, "editing", !this.item.editing);
    },
  },
};
</script>
